import script from "./SelectGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectGroupModal.vue?vue&type=style&index=0&id=7d6b7e8a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6b7e8a"]])

export default __exports__